'use strict';

$ = jQuery;

/*
* Evento de clique nos cards do estilo de vida
*/
$('.jc-card-lifestyle').on('click', 'a', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Estilo de vida',
    'eventLabel': $(this).text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Estilo de vida',
    'eventLabel': $(this).text().trim()
  });
});